import { __assign, __rest } from "tslib";
import React from 'react';
import VeltMediaSourceSettingsToggleIconOpenWireframe from './VeltMediaSourceSettingsToggleIconOpenWireframe/VeltMediaSourceSettingsToggleIconOpenWireframe';
import VeltMediaSourceSettingsToggleIconCloseWireframe from './VeltMediaSourceSettingsToggleIconCloseWireframe/VeltMediaSourceSettingsToggleIconCloseWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltMediaSourceSettingsToggleIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-toggle-icon-wireframe", __assign({}, transformedProps), children));
};
VeltMediaSourceSettingsToggleIconWireframe.Open = VeltMediaSourceSettingsToggleIconOpenWireframe;
VeltMediaSourceSettingsToggleIconWireframe.Close = VeltMediaSourceSettingsToggleIconCloseWireframe;
export default VeltMediaSourceSettingsToggleIconWireframe;
